const ensureLinkIsFullUrl = (url: string): string => {
  if (!url || url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return `https://${url}`;
};

export default ensureLinkIsFullUrl;
